<template>
  <v-container
    class="tag-list-height checklist-page-height"
    :class="[internal ? 'pa-0' : '', { 'settings-footer-bottom': !internal }]"
    fluid
    v-if="getPermission('setting:view')"
  >
    <v-layout class="mb-3">
      <v-flex>
        <h3
          class="font-weight-700 mb-0 font-size-24 custom-headline color-custom-blue"
        >
          Checklists
        </h3>
      </v-flex>

      <div>
        <v-btn
          depressed
          small
          class="text-white mr-2"
          color="cyan"
          v-on:click="
            $router.push(getDefaultRoute('serviceFormTemplate.create'))
          "
          :disabled="dataLoading"
          :loading="dataLoading"
        >
          <span class="font-size-16 font-weight-600">Create</span>
        </v-btn>
      </div>
      <div class="" v-if="!internal">
        <v-btn
          depressed
          class="custom-grey-border custom-bold-button"
          v-on:click="goBack"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </div>
    </v-layout>
    <ListingTable :columnCount="4" :rowData="templateDataArr">
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="simple-table-th" width="20%">Title</th>
            <th class="simple-table-th" width="30%">Description</th>
            <th class="simple-table-th">Equipment Count</th>
            <th class="simple-table-th">Active/In-Active</th>
            <th class="simple-table-th">Added by</th>
            <th class="simple-table-th text-end" width="10%">Action</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="templateDataArr.length">
            <tr
              v-for="(row, index) in templateDataArr"
              :key="index"
              class="alternate-listing-row"
            >
              <td
                class="simple-table-td text-capitalize pl-4"
                v-on:click="goToDetail(row.id)"
              >
                {{ row.title }}
              </td>
              <td
                class="simple-table-td text-capitalize pl-4"
                v-on:click="goToDetail(row.id)"
              >
                {{ row.description }}
              </td>
              <td
                class="simple-table-td text-capitalize pl-4"
                v-on:click="goToDetail(row.id)"
              >
                <v-avatar size="22" color="blue" class="white--text" left>
                  {{ row.equipment_count }}
                </v-avatar>
              </td>
              <td class="simple-table-td pl-4">
                <v-switch
                  v-model="row.activated"
                  true-value="1"
                  false-value="0"
                  class="mt-0"
                  inset
                  v-on:click.prevent.stop="activeInactive(row)"
                  color="green"
                ></v-switch>
              </td>
              <td class="simple-table-td pl-4" v-on:click="goToDetail(row.id)">
                <TableActivity v-if="!lodash.isEmpty(row.added_by)" :data="row">
                  <template v-slot:first_letters>
                    {{ getFirstLetters(row.display_name) }}
                  </template>
                  <template v-slot:display_name>
                    {{ row.display_name }}
                  </template>
                  <template v-slot:date_time>
                    <template>{{ row.added_at }}</template>
                  </template>
                  <template v-slot:format_date_time>
                    {{ row.added_at }}
                  </template>
                </TableActivity>
              </td>
              <td class="simple-table-td text-end">
                <v-icon
                  color="cyan"
                  class="me-2"
                  size="20"
                  v-on:click="
                    $router.push(
                      getDefaultRoute('serviceFormTemplate.update', {
                        params: { id: row.id },
                      })
                    )
                  "
                >
                  mdi-pencil</v-icon
                >
                <v-icon color="red" size="20" v-on:click="deleteJob(row.id)">
                  mdi-delete</v-icon
                >
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="5">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  Uhh... There are no Form at the moment.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </ListingTable>
    <ListingFooter
      v-if="templateDataArr.length"
      :dataLoading="dataLoading"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :totalPages="totalPages"
      removePage
    >
    </ListingFooter>

    <DeleteDialog :delete-dialog="deleteCategoryDialog">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3 class="font-size-18 font-weight-600 delete-text">
          Are you sure you want to delete this ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="deleteJobLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deleteCategoryDialog = false"
          >No! Cancel</v-btn
        >
        <v-btn
          depressed
          :disabled="deleteJobLoading"
          :loading="deleteJobLoading"
          color="red lighten-1 white--text"
          v-on:click="deleteChecklist()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteDialog>
  </v-container>
</template>

<script>
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import DeleteDialog from "@/view/pages/partials/Delete";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import { QUERY, PUT, DELETE } from "@/core/services/store/request.module";
import { SuccessEventBus } from "@/core/lib/message.lib";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
export default {
  mixins: [CommonMixin],
  name: "serviceFormTemplateSetting",
  data() {
    return {
      type: null,
      rowsOffset: 0,
      isCheckbox: false,
      templateDataArr: [],
      formValid: true,
      deleteJobLoading: false,
      related_id: null,
      is_exist: 0,
      related_type: null,
      type_filter: null,

      deleteCategoryDialog: false,
      deleteId: false,
      confirm_dialog: false,
      confirm_loading: false,
      dataLoading: false,
      currentPage: 1,
      totalPages: 0,
      totalRows: 0,
    };
  },
  props: {
    internal: {
      type: Boolean,
      default: false,
    },
    module: {
      type: String,
      default: null,
    },
  },
  methods: {
    deleteChecklist() {
      const _this = this;
      _this.$store
        .dispatch(DELETE, {
          url: `setting/checklist/${_this.deleteId}`,
        })
        .then((response) => {
          SuccessEventBus.$emit("update:success", response.message);
          _this.deleteCategoryDialog = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.getServiceFormTemplates();
        });
    },
    deleteJob(id) {
      this.deleteCategoryDialog = true;
      this.deleteId = id;
    },
    goToDetail(id) {
      const _this = this;
      _this.$router.push(
        _this.getDefaultRoute("serviceFormTemplate.details", {
          params: { id: id },
        })
      );
    },
    activeInactive(data) {
      const _this = this;
      if (data.activated == false) {
        data.activated = 0;
      } else {
        data.activated = 1;
      }
      _this.$store
        .dispatch(PUT, {
          url: `setting/checklist/status`,
          data: {
            ids: [data.id],
            activated: data.activated,
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.getServiceFormTemplates();
        });
    },
    downloadPdf() {
      const pdfUrl = "https://example.com/sample.pdf";
      window.open(pdfUrl, "_blank");
    },

    handlePagination(page) {
      this.currentPage = page;
      this.getServiceFormTemplates();
    },
    getServiceFormTemplates() {
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "setting/checklists",
          data: { current_page: _this.currentPage },
        })
        .then(({ data }) => {
          _this.currentPage = Number(data.current_page) || _this.currentPage;
          _this.templateDataArr = data.rows;
          _this.rowsOffset = data.offset;
          _this.totalRows = data.total_rows;
          _this.totalPages = Math.ceil(data.total_rows / data.per_page);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.templateDataArr) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      return (
        this.rowsOffset +
        (this.templateDataArr ? this.templateDataArr.length : 0)
      );
    },
  },
  mounted() {
    PaginationEventBus.$on("update:pagination", this.handlePagination);
    this.getServiceFormTemplates();
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination", this.handlePagination);
  },
  components: {
    DeleteDialog,
    ListingTable,
    ListingFooter,
    TableActivity,
  },
};
</script>
